import commonMixin from '../mixins/_common';
import modalMixin from '../mixins/_modal';
import flashMessageMixin from '../mixins/_flash_messages';
import imageSelecter from '../components/_image_selecter';

/**
 * テンプレート設定コンポーネント
 */
export default {
    name: 'TemplateConfigEditor',
    template: '#template_config_editor_template',
    data () {
        return {
            // 編集index
            index: null,
            // 編集ID
            edit_id: null,
            // 設定データ
            config: {},
        };
    },
    props: {
        // テンプレートタイプ build_store|item|custom_page
        type: {
            type: String,
            required: true,
            validator: function (value) {
                return ['build_store', 'item', 'custom_page'].indexOf(value) !== -1;
            }
        },
        // 商品リスト
        templates: {
            type: Array,
            default: () => ([]),
            require: true,
        },
    },
    components: {
        // 画像の選択、UPロードを操作するコンポーネント
        'image-selecter': imageSelecter,
    },
    mixins: [
        commonMixin,
        modalMixin,
        flashMessageMixin
    ],
    emits: ['update:templates'],
    methods: {
        // 編集データをセット
        setData: function (index) {
            const template = this.templates[index];
            // 編集IDをセット
            this.edit_id = template.edit_id;
            // 設定値をセット
            this.config = _.cloneDeep(template.template_config);
            // 編集index
            this.index = index;
        },
        // 設定モーダルを開く
        show: function (index) {
            this.setData(index);
            this.open();
        },
        // 設定を更新する
        update: async function (event) {
            if (!event?.target?.form?.checkValidity()) {
                return;
            }
            event.preventDefault();

            let message = this.exception_error_message;
            try {
                this.$_loading();
                const response = await axios.post('/admin/update_template_config', {
                    _method: 'PUT',
                    type: this.type,
                    edit_id: this.edit_id,
                    config: this.config,
                });
                if (response.data.status === 'OK') {
                    // エラーメッセージを空にする
                    message = '';
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.$_unloading();
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                });
                return;
            }
            await swal('更新しました');
            this.close();
            this.emitUpdateTemplateConfig();
        },

        // -------------------------
        // emit
        // -------------------------

        // リストを更新して親へ通知
        emitUpdateTemplateConfig: function () {
            let templates = _.cloneDeep(this.templates);
            templates[this.index].template_config = this.config;
            this.$emit('update:templates', templates);
        }
    }
};